import React, { useEffect, useState } from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

import './style.scss';
import { getEnv, getIdFromUrl, getSdkVersionFromUrl } from '../../utils';
import PaymenttoolsSDK from '../../../types/PaymenttoolsSDK';
import { PaymentProps } from '../../components/PageLayout/types';

declare const Paymenttools: PaymenttoolsSDK;

const Payment = ({ displayLogo, isSessionLoaded, isSessionExpired }: PaymentProps) => {
  const [dropInLoadingFailed, setDropInLoadingFailed] = useState<boolean>(false);
  const [ptSdkScriptLoaded, setPtSdkScriptLoaded] = useState<boolean>(false);
  const { t } = useTranslation(['error']);

  useEffect(() => {
    if (!isSessionLoaded && !isSessionExpired) return;
    getEnv()
      .then(({ sdkLibraryUrl, sdkVersionToSriHash }) => {
        if (sdkLibraryUrl) {
          const ptSdkScript = document.createElement('script');
          ptSdkScript.src = sdkLibraryUrl;

          const sdkVersion = getSdkVersionFromUrl(sdkLibraryUrl);
          const integrity = sdkVersion ? sdkVersionToSriHash?.[sdkVersion] : undefined;
          if (integrity) {
            ptSdkScript.integrity = integrity;
            ptSdkScript.crossOrigin = 'anonymous';
          }

          ptSdkScript.addEventListener('load', () => {
            setPtSdkScriptLoaded(true);
          });
          document.head.prepend(ptSdkScript);
        }
      })
      .catch(() => {
        setDropInLoadingFailed(true);
      });
  }, [isSessionLoaded, isSessionExpired]);

  useEffect(() => {
    if (ptSdkScriptLoaded) {
      const sessionId = getIdFromUrl();
      try {
        const dropIn = new Paymenttools.DropIn('sdk-container', {
          sessionId,
          language: i18next.language,
          displayLogo
        });

        i18next.on('languageChanged', (language) => {
          dropIn.changeLanguage(language);
        });
      } catch (error) {
        setDropInLoadingFailed(true);
      }
    }
  }, [ptSdkScriptLoaded, displayLogo]);

  return (
    <div id="sdk-container">
      {dropInLoadingFailed && <div>{t('error:dropInLoadingFailed')}</div>}
    </div>
  );
};

export default Payment;
